import mixpanel from "mixpanel-browser";
import { TransferFlow } from "../typings";

const Analytics = {
  track: ({ name, properties = {} }: { name: string; properties?: Record<string, any> }) => {
    mixpanel.track(name, { ...properties });
  },
  setUserProfiles: ({
    userName,
    userEmail,
    partnerName,
    partnerId,
    transferFlow,
  }: {
    userName: string;
    userEmail: string;
    partnerName: string;
    partnerId: string;
    transferFlow: TransferFlow;
  }) => {
    mixpanel?.identify(userEmail.toLowerCase());
    mixpanel?.people.set({
      $name: userName,
      $email: userEmail,
      partnerName,
      partnerId,
      transferFlow,
    });
  },
  setPartnerName: (partnerName: string) => {
    mixpanel.register({ partnerName });
  },
};

export default Analytics;
